// Display helpers for a plan influencer row — shared by the Plans table, the
// Plan Summary header and the Script Approval screens.

export const formatCompact = (num) => {
  if (num === null || num === undefined) return "—";
  return new Intl.NumberFormat("en", { notation: "compact" }).format(num);
};

// Some records store a platform-prefixed key (e.g. "yt/@handle", "fb/handle")
// used internally for DB lookups — strip that prefix for display.
export const formatUsername = (username) => {
  if (!username) return null;
  // "tw/" (X) and "li/" (LinkedIn) are the same kind of internal prefix as "yt/"; a LinkedIn
  // company page is stored as "li/c/<slug>" and shown as "company/<slug>".
  const cleaned = username
    .replace(/^li\/c\//, "company/")
    .replace(/^(yt|fb|t|tw|li)\//, "")
    .replace(/^@/, "");
  return cleaned || null;
};
